module.exports = __webpack_public_path__ + "img/Girl_010005.28ba4b28.png";